/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { GdsRcptSync01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const gdsRcptSync01ShowSyncSettingLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const gdsRcptSync01ShowSyncSettingSuccess = (state, { syncSetting }) => ({
  ...state,
  syncSetting
});

export const gdsRcptSync01ShowBatchJobStatusSuccess = (state, { batchJobStatus }) => ({
  ...state,
  batchJobStatus
});

export const gdsRcptSync01ExportLoading = (state, { boolean }) => ({
  ...state,
  exportIsLoading: boolean
});

export const gdsRcptSync01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const gdsRcptSync01FetchGdsRcptSync01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const gdsRcptSync01FetchGdsRcptSync01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const gdsRcptSync01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const gdsRcptSync01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const gdsRcptSync01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const gdsRcptSync01ExportSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

export const gdsRcptSync01SetExpandedRows = (state, { expandedRows }) => ({
  ...state,
  expandedRows
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [GdsRcptSync01Types.GDS_RCPT_SYNC01_SHOW_SYNC_SETTING_LOADING]: gdsRcptSync01ShowSyncSettingLoading,
  [GdsRcptSync01Types.GDS_RCPT_SYNC01_SHOW_SYNC_SETTING_SUCCESS]: gdsRcptSync01ShowSyncSettingSuccess,
  [GdsRcptSync01Types.GDS_RCPT_SYNC01_SHOW_BATCH_JOB_STATUS_SUCCESS]: gdsRcptSync01ShowBatchJobStatusSuccess,

  [GdsRcptSync01Types.GDS_RCPT_SYNC01_RESET_TIMESTAMP]: gdsRcptSync01ResetTimestamp,
  [GdsRcptSync01Types.GDS_RCPT_SYNC01_FETCH_GDS_RCPT_SYNC01_LOADING]: gdsRcptSync01FetchGdsRcptSync01Loading,
  [GdsRcptSync01Types.GDS_RCPT_SYNC01_FETCH_GDS_RCPT_SYNC01_SUCCESS]: gdsRcptSync01FetchGdsRcptSync01Success,
  [GdsRcptSync01Types.GDS_RCPT_SYNC01_ADD_SELECTED_DOCUMENTS]: gdsRcptSync01AddSelectedDocuments,
  [GdsRcptSync01Types.GDS_RCPT_SYNC01_REMOVE_SELECTED_DOCUMENTS]: gdsRcptSync01RemoveSelectedDocuments,
  [GdsRcptSync01Types.GDS_RCPT_SYNC01_SET_WORKSPACE_VISIBLE]: gdsRcptSync01SetWorkspaceVisible,
  [GdsRcptSync01Types.GDS_RCPT_SYNC01_EXPORT_LOADING]: gdsRcptSync01ExportLoading,
  [GdsRcptSync01Types.GDS_RCPT_SYNC01_EXPORT_SUCCESS]: gdsRcptSync01ExportSuccess,

  [GdsRcptSync01Types.GDS_RCPT_SYNC01_SET_EXPANDED_ROWS]: gdsRcptSync01SetExpandedRows
});
